import * as React from 'react';

export function ForbiddenPage() {
    return (
        <div className="error-card white-background">
            <h1>Forbidden</h1>
            <h3>You are not allowed to visit this page</h3>
        </div>
    );
}
